import PdfPreview from './PdfPreview'
export default PdfPreview
